module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headNav-page"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h3', {
    staticClass: "noPrint"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("上海高职高专师资公共培训基地")])], 1), (this.$route.path != '/signUp' && this.$route.path != '/signIn') ? _c('el-menu', {
    staticClass: "el-menu-demo noPrint",
    attrs: {
      "background-color": "#2f4157",
      "active-text-color": "#fff",
      "text-color": "#888",
      "default-active": _vm.$route.path,
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("教学研究会")])], 1), _c('el-menu-item', {
    attrs: {
      "index": "/train"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/train"
    }
  }, [_vm._v(" 培训平台")])], 1), _c('el-menu-item', {
    attrs: {
      "index": "/competes"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/competes"
    }
  }, [_vm._v(" 比赛平台")])], 1), _c('el-menu-item', {
    attrs: {
      "index": "/research/activities"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/research/activities"
    }
  }, [_vm._v("教改项目")])], 1), _c('el-menu-item', {
    attrs: {
      "index": "/meeting/reserve"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/meeting/reserve"
    }
  }, [_vm._v("培训室预约")])], 1), _c('el-menu-item', {
    attrs: {
      "index": "/videos"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/videos"
    }
  }, [_vm._v("资源展示")])], 1), (!_vm.isUserAuth && !_vm.isExpertAuth) ? _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/signIn"
    }
  }, [_vm._v("注册")])], 1) : _vm._e(), (!_vm.isUserAuth && !_vm.isExpertAuth) ? _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/signUp"
    }
  }, [_vm._v("登录")])], 1) : _vm._e(), (_vm.isUserAuth || _vm.isExpertAuth) ? _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_c('el-dropdown', {
    staticClass: "el-dropdown-btn",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v(_vm._s(_vm.userName ? _vm.userName : '用户名')), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": _vm.isExpertAuth ? '/expert' : '/user'
    }
  }, [_vm._v("个人中心")])], 1), _c('el-dropdown-item', [_c('div', {
    staticClass: "logout",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3ccc4f0","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Compete/common/HeadNav.vue
// module id = 576
// module chunks = 85